import { useEffect, Component } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Styles from "@/components/Styles";
import BeforeAfter from "@/components/BeforeAfter";
import VibePicker from "@/components/VibePicker";
import Founder from "@/components/Founder";
import Process from "@/components/Process";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

class ErrorBoundary extends Component {
    state = { err: false };
    static getDerivedStateFromError() {
        return { err: true };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="min-h-screen grid place-items-center bg-noir text-white font-sans p-8 text-center">
                    <p>Something went wrong. Please refresh the page.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <div className="bg-noir min-h-screen">
                    <Nav />
                    <main>
                        <Hero />
                        <Marquee />
                        <Manifesto />
                        <Styles />
                        <BeforeAfter />
                        <VibePicker />
                        <Founder />
                        <Process />
                        <Faq />
                        <Contact />
                    </main>
                    <FloatingWhatsApp />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
